import React from 'react';
import { FileText, Download } from 'lucide-react';
export function ProductSpecs() {
  return <div className="mt-12" data-id="element-161">
      {/* Summary Banner */}
      <div className="bg-brand-charcoal text-white p-4 rounded-t-lg flex flex-wrap gap-x-8 gap-y-2 text-sm font-mono border-b-4 border-brand-red" data-id="element-162">
        <span data-id="element-163">DIA=1/8"</span>
        <span data-id="element-164">LOC=1/4"</span>
        <span data-id="element-165">OAL=1-1/2"</span>
        <span data-id="element-166">SHK=1/8"</span>
        <span data-id="element-167">CR=.005"</span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8" data-id="element-168">
        {/* Left Column */}
        <div className="space-y-8" data-id="element-169">
          <section data-id="element-170">
            <h3 className="text-lg font-bold text-brand-charcoal border-b-2 border-gray-200 pb-2 mb-4 flex items-center gap-2" data-id="element-171">
              <FileText className="w-5 h-5 text-brand-darkGold" data-id="element-172" />
              General Specifications
            </h3>
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-173">
              <table className="w-full text-sm" data-id="element-174">
                <tbody data-id="element-175">
                  <tr className="border-b border-gray-100" data-id="element-176">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700 w-1/2" data-id="element-177">
                      Brand
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-178">TITAN</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-179">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-180">
                      Series
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-181">TV42SR</td>
                  </tr>
                  <tr data-id="element-182">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-183">
                      Performance
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-184">
                      High Performance
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section data-id="element-185">
            <h3 className="text-lg font-bold text-brand-charcoal border-b-2 border-gray-200 pb-2 mb-4" data-id="element-186">
              Diameter Specifications
            </h3>
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-187">
              <table className="w-full text-sm" data-id="element-188">
                <tbody data-id="element-189">
                  <tr className="border-b border-gray-100" data-id="element-190">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700 w-1/2" data-id="element-191">
                      Diameter Information
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-192">0.1250 1/8"</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-193">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-194">
                      Diameter Tolerance
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-195">+.000" -.002"</td>
                  </tr>
                  <tr data-id="element-196">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-197">
                      OD Grind
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-198">Eccentric</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section data-id="element-199">
            <h3 className="text-lg font-bold text-brand-charcoal border-b-2 border-gray-200 pb-2 mb-4" data-id="element-200">
              Shank Specifications
            </h3>
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-201">
              <table className="w-full text-sm" data-id="element-202">
                <tbody data-id="element-203">
                  <tr className="border-b border-gray-100" data-id="element-204">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700 w-1/2" data-id="element-205">
                      Shank Diameter
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-206">1/8"</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-207">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-208">
                      Shank Tolerance
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-209">-.0001" -.0004"</td>
                  </tr>
                  <tr data-id="element-210">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-211">
                      Shank Type
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-212">Straight</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>

        {/* Right Column */}
        <div className="space-y-8" data-id="element-213">
          <section data-id="element-214">
            <h3 className="text-lg font-bold text-brand-charcoal border-b-2 border-gray-200 pb-2 mb-4" data-id="element-215">
              Length Specifications
            </h3>
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-216">
              <table className="w-full text-sm" data-id="element-217">
                <tbody data-id="element-218">
                  <tr className="border-b border-gray-100" data-id="element-219">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700 w-1/2" data-id="element-220">
                      Flute Length
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-221">1/4"</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-222">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-223">
                      Neck Length
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-224">~~~</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-225">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-226">
                      Overall Length
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-227">1-1/2"</td>
                  </tr>
                  <tr data-id="element-228">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-229">
                      Length Category
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-230">Stub</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section data-id="element-231">
            <h3 className="text-lg font-bold text-brand-charcoal border-b-2 border-gray-200 pb-2 mb-4" data-id="element-232">
              Fluting Geometry
            </h3>
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-233">
              <table className="w-full text-sm" data-id="element-234">
                <tbody data-id="element-235">
                  <tr className="border-b border-gray-100" data-id="element-236">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700 w-1/2" data-id="element-237">
                      Number of Flutes
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-238">4</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-239">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-240">
                      Helix Angle
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-241">38 degrees</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-242">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-243">
                      Flute Index
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-244">Varied</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-245">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-246">
                      Cut
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-247">
                      Center Cutting Right Hand
                    </td>
                  </tr>
                  <tr data-id="element-248">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-249">
                      Spiral
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-250">Right Hand</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section data-id="element-251">
            <h3 className="text-lg font-bold text-brand-charcoal border-b-2 border-gray-200 pb-2 mb-4" data-id="element-252">
              Coating & Configuration
            </h3>
            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-253">
              <table className="w-full text-sm" data-id="element-254">
                <tbody data-id="element-255">
                  <tr className="border-b border-gray-100" data-id="element-256">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700 w-1/2" data-id="element-257">
                      Coating
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-258">AlCrN</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-259">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-260">
                      End Type
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-261">
                      Single End Corner Radius
                    </td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-262">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-263">
                      Corner Radius
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-264">.005"</td>
                  </tr>
                  <tr className="border-b border-gray-100" data-id="element-265">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-266">
                      Corner Chamfer
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-267">~~~</td>
                  </tr>
                  <tr data-id="element-268">
                    <td className="py-3 px-4 bg-gray-50 font-semibold text-gray-700" data-id="element-269">
                      Materials Families
                    </td>
                    <td className="py-3 px-4 text-gray-900" data-id="element-270">
                      All (P, K, M, S, H)
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>

      {/* Feeds & Speeds */}
      <section className="mt-12 bg-brand-gray border border-gray-200 rounded-lg p-6" data-id="element-271">
        <h3 className="text-xl font-bold text-brand-charcoal mb-3" data-id="element-272">
          Feeds & Speeds
        </h3>
        <p className="text-gray-600 mb-4 text-sm" data-id="element-273">
          Click on the Download link below and a PDF file will open displaying a
          printable Feeds and Speeds Chart specific for the tool selected.
        </p>
        <a href="https://www.6gtools.com/products/custom/uploaded/files/feedsandspeeds/Feeds_and_Speeds_Titan_VI-Pro_4%20Flute.pdf" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-brand-red hover:text-red-700 font-semibold transition-colors" data-id="element-274">
          <Download className="w-5 h-5" data-id="element-275" />
          Feeds and Speeds Download (0.37 MB)
        </a>
      </section>
    </div>;
}